import { useState, useEffect } from "react";
import MatchConfidenceMain from "components/SystemLevelSettings/MatchConfidence/MatchConfidenceMain";
import MainLayout from 'layouts/mainLayout'
import * as api from '../../api/endpoints/partnerService'

const matchConfidenceData = [
  {
    "label": "Markaaz Match Confidence Threshold",
    "items": [
      {
        "checkboxKey": "isMatchConfidenceScoreChecked",
        "label": "Markaaz Match Confidence Score Threshold",
        "tooltipContent": "The match confidence score is an analysis of the match confidence level on a 10 to 1 scale. Match Confidence is strongest at 10 (representing a very high level of the match on all data elements present) and weakest at 1 (representing a match on Name only).",
        "required": true,
        "isError": false,
        "slider": {
          "min": 1,
          "max": 10,
          "step": 0.1,
          "marks": [
            { "value": 1, "label": "1" },
            { "value": 2, "label": "2" },
            { "value": 3, "label": "3" },
            { "value": 4, "label": "4" },
            { "value": 5, "label": "5" },
            { "value": 6, "label": "6" },
            { "value": 7, "label": "7" },
            { "value": 8, "label": "8" },
            { "value": 9, "label": "9" },
            { "value": 10, "label": "10" }
          ],
          "valueLabelFormat": {
            "formatter": "confidenceScoreRange"
          },
          "valueKey": "matchConfidenceScoreLowerLimit",
          "sx": "risk",
          "track": "inverted"
        }
      }
    ]
  }
]

const MatchConfidencePage = () => {
  const [matchConfidence, setMatchConfidence] = useState(null)
  const [submitInProgress, setSubmitInProgress] = useState(false)
  const [showNotification, setShowNotification] = useState({ type: '', message: '' })
  

  useEffect(() => {
    loadMatchThreshold()
  }, [])

  function handleSliderChange(rowData) {
    return function (_, value) {
      setMatchConfidence({ epId: 1, matchConfidenceScoreLowerLimit: value })
    };

  }

  function handleAlertClose() {
    setShowNotification(false)
  }

  function loadMatchThreshold() {
    api.getMatchConfidenceTheshold().then(res => {
      setMatchConfidence({ epId: 1, matchConfidenceScoreLowerLimit: res.matchConfidenceThreshold })
    })
  }

  async function handleSubmit() {
    setSubmitInProgress(true)
    try {
      const config = {
        matchConfidenceThreshold: matchConfidence.matchConfidenceScoreLowerLimit,
      }
      await api.postMatchConfidenceTheshold(config)
      setShowNotification({
        type: 'success',
        message: 'Successfully Updated',
      })
    } catch (error) {
      setShowNotification({
        type: 'error',
        message: 'Something went wrong. Please try after some time.',
      })
    } finally {
      setSubmitInProgress(false)
    }
  }

  return (
    <MainLayout>
      <MatchConfidenceMain
        values={matchConfidence}
        data={matchConfidenceData}
        submitInProgress={submitInProgress}
        showNotification={showNotification}
        onAlertClose={handleAlertClose}
        onSliderChange={handleSliderChange}
        onSubmit={handleSubmit}
        onReset={loadMatchThreshold}
        isPartnerChanged={false}
      /></MainLayout>
  )
};

export default MatchConfidencePage;
